import React, { useState } from 'react'; import { List, Datagrid, ImageField, TextField, NumberField, useNotify, useRefresh, useMutation, EditButton, DeleteWithConfirmButton, TextInput, Filter, Button as RaButton, usePermissions } from 'react-admin';
import {
    Button, Menu, MenuItem, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core"
import CheckIcon from '@material-ui/icons/Check';

import { _enumNotiStatus } from '../../utils/enum';

import { USER_GROUP_ADMIN } from '../../utils/const';
import { Pagination, EnumField, DateField, LinkField } from "../../partials"
import QRCode from "react-qr-code";

const FilterComponents = (props) => {
    return (
        <Filter {...props}>
            <TextInput source="title" label="Title" />
        </Filter>
    );
};

const ShowQrDialog = ({ open, record, handleClose }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                {record.name}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {record.description}
                    <br />
                    <hr />
                    <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={record.id}
                        viewBox={`0 0 256 256`}
                    />
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
}

const ButtonComponent = (props) => {
    const { record = {} } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button aria-controls="simple-menu" aria-haspopup="true"
                disabled={record.status === "NOTIFICATION_MASTER_STATUS_DELETED"}
                onClick={handleClick}>...</Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem fullWidth onClick={handleClose}>
                    <EditButton {...props} />
                </MenuItem>
            </Menu>
        </div>
    )
};

const ListComponent = (props) => {
    const { permissions: auth } = usePermissions();

    return (
        <List {...props} pagination={<Pagination />} perPage={20} bulkActionButtons={false}/*  filters={<FilterComponents />} */ sort={{ field: 'holiday_date', order: 'DESC' }} >
            <Datagrid>
                <TextField source="date" label="Date" />
                <TextField source="messages" label="Messages" />
                <ButtonComponent  {...props} />
            </Datagrid>
        </List>
    );
}

export default ListComponent
